"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CoreQuadList {
    constructor() {
        this.quadTextures = [];
        this.quadElementCores = [];
    }
    get length() {
        return this.quadTextures.length;
    }
    reset() {
        this.quadTextures = [];
        this.quadElementCores = [];
    }
    getElement(index) {
        return this.quadElementCores[index].element;
    }
    getElementCore(index) {
        return this.quadElementCores[index];
    }
    getTexture(index) {
        return this.quadTextures[index];
    }
    getTextureWidth(index) {
        const nativeTexture = this.quadTextures[index];
        if (nativeTexture.w) {
            // Render texture;
            return nativeTexture.w;
        }
        else {
            return this.quadElementCores[index].displayedTextureSource.w;
        }
    }
    getTextureHeight(index) {
        const nativeTexture = this.quadTextures[index];
        if (nativeTexture.h) {
            // Render texture;
            return nativeTexture.h;
        }
        else {
            return this.quadElementCores[index].displayedTextureSource.h;
        }
    }
    add(texture, elementCore) {
        this.quadTextures.push(texture);
        this.quadElementCores.push(elementCore);
    }
}
exports.CoreQuadList = CoreQuadList;
//# sourceMappingURL=CoreQuadList.js.map